module.exports = __webpack_public_path__ + "static/media/callIcon.0e63536f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calls/callIcon.svg
// module id = 1246
// module chunks = 0